import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { setErr("Le password non coincidono"); return; }
    if (pw.length < 6) { setErr("Almeno 6 caratteri"); return; }
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password aggiornata. Ora puoi accedere.");
      nav("/accedi");
    } catch (ex) { setErr(formatErr(ex.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#F9F8F6]">
        <Navbar />
        <div className="max-w-md mx-auto px-6 py-16">
          <h1 className="font-serif-display text-3xl text-[#1E3F33]">Link non valido</h1>
          <p className="mt-2 text-[#6B6B6B]">Il link di reset è incompleto. Richiedine uno nuovo.</p>
          <Link to="/password-dimenticata" data-testid="reset-request-new" className="btn-lift inline-block mt-6 px-4 py-2 bg-[#1E3F33] text-white rounded-md">Richiedi nuovo link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif-display text-4xl text-[#1E3F33]">Nuova password</h1>
        <p className="mt-2 text-[#6B6B6B]">Scegli una nuova password per il tuo account.</p>
        <form onSubmit={submit} className="mt-8 card-flat p-6 space-y-4">
          <div>
            <label className="label-caps block mb-2">Nuova password (min 6)</label>
            <input data-testid="reset-password" type="password" required minLength={6} value={pw} onChange={e=>setPw(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          <div>
            <label className="label-caps block mb-2">Conferma password</label>
            <input data-testid="reset-confirm" type="password" required value={confirm} onChange={e=>setConfirm(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          {err && <div data-testid="reset-error" className="text-sm text-[#A83C22]">{err}</div>}
          <button data-testid="reset-submit" disabled={loading} className="btn-lift w-full py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24] disabled:opacity-60">
            {loading ? "Aggiornamento…" : "Aggiorna password"}
          </button>
        </form>
      </div>
    </div>
  );
}
